import { createApp } from "vue"
import App from "./App.vue"
import * as EvaIcons from "@stefandesu/eva-icons-vue"

EvaIcons.EvaIcon.register({
  name: "whatsapp",
  content: `<g data-name="Layer 2"><g data-name="whatsapp"><rect width="24" height="24" opacity="0"/><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.196 8.196 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24m-3.53 3.42c-.2 0-.43.07-.65.32-.22.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.12.16 1.74 2.65 4.21 3.72.59.25 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.17-.48-.29-.25-.13-1.47-.73-1.7-.81-.23-.08-.39-.13-.56.12-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.39-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.16.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43h-.48z"/></g></g>`
})
import router from "./router"
import ActionCableVue from "actioncable-vue"
import BootstrapVue3 from 'bootstrap-vue-3'
import VueApexCharts from "vue3-apexcharts"
import vClickOutside from "click-outside-vue3"
import Maska from 'maska'

import 'sweetalert2/dist/sweetalert2.min.css'
import '@vueform/slider/themes/default.css'
import './assets/scss/custom/plugins/mermaid.min.css'
import 'vue-multiselect/dist/vue-multiselect.css'

import store from "./state/store"

import IU from '@/IU/IU.js'
// Carga de variables globales
window.iu = new IU() // Controlador de la interfaz de usuario de ArgusBlack

import "./assets/scss/app.scss"
import './registerServiceWorker'
import './broadcasting/main.js'

const websocketOptions = {
  debug: true,
  debugLevel: "error",
  connectionUrl: "http://localhost:8080/",
  connectImmediately: false
};

createApp(App)
  .use(store)
  .use(EvaIcons)
  .use(router)
  .use(BootstrapVue3)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(Maska)
  .use(ActionCableVue, websocketOptions)
  .mount("#app")
